// The only reader of import.meta.env (UI architecture §15): the three build-time variables of environments §3.4.
const environments = ['local', 'test', 'demo', 'staging', 'production'] as const;

export type AppEnv = (typeof environments)[number];

const env = import.meta.env;

function appEnv(value: string | undefined): AppEnv {
  return environments.find((name) => name === value) ?? 'local';
}

export const config = {
  apiBaseUrl: env.VITE_API_BASE_URL ?? '',
  mockMode: env.VITE_MOCK_MODE === 'true',
  env: appEnv(env.VITE_ENV),
  dev: env.DEV,
} as const;
